const openQuickShopModal = (product) => {
  // The "product" parameter contains values from the tolstoy spotlight carousel that you can use as a handle into which values to render on the modal.
  var productUrl = 'https://patrickta.com/products/' + product.handle;

  // Reuse one modal element across clicks. QuickBuyModal empties itself on dialog:after-hide,
  // so a fresh fetch still renders the right product; creating one per click left every
  // previously opened modal stranded in the DOM.
  var quickBuyModal = document.querySelector('quick-buy-modal.tolstoy-product-quick-shop');

  if (!quickBuyModal) {
    // Build the modal from markup rather than document.createElement.
    //
    // `document.createElement('quick-buy-modal')` constructs the custom element
    // SYNCHRONOUSLY, and the spec forbids a custom element constructor from giving
    // itself attributes. QuickBuyModal (via Modal -> DialogElement) does exactly
    // that, so the call throws:
    //
    //   NotSupportedError: Failed to execute 'createElement' on 'Document':
    //   The result must not have attributes
    //
    // The throw happened before any /cart/add.js request was made, which is why the
    // Tolstoy carousel's add-to-cart did nothing at all - no network call, no error
    // surfaced to the shopper. That is BugHerd #183, #386 and #419.
    //
    // Parsing markup instead means the element is UPGRADED rather than constructed
    // in place: attributes exist before the constructor runs, so the check does not
    // apply. The resulting element is the same upgraded QuickBuyModal.

    // Match snippets/product-card__quick-buy.liquid: `modal--quick-buy` widens the dialog and
    // applies the quick-buy body layout, and the colour-scheme classes give it its background.
    // The scheme is copied from an existing modal where possible so it follows the theme setting.
    const schemeSource = document.querySelector('quick-buy-modal[class*="color-scheme--"]');
    const schemeClasses = schemeSource
      ? Array.from(schemeSource.classList).filter((c) => c.indexOf('color-scheme') === 0).join(' ')
      : 'color-scheme color-scheme--scheme-2';

    const modalHolder = document.createElement('div');
    modalHolder.innerHTML =
      '<quick-buy-modal class="modal modal--quick-buy ' + schemeClasses +
      ' tolstoy-product-quick-shop"></quick-buy-modal>';
    quickBuyModal = modalHolder.firstElementChild;
    document.body.appendChild(quickBuyModal);
  }

  // `handle` comes from third-party event data, so it is set via setAttribute rather than
  // interpolated into an HTML string.
  quickBuyModal.setAttribute('handle', product.handle);
  quickBuyModal.setAttribute('product-url', productUrl);

  // Hand off to the theme's own open path. QuickBuyModal.show() fetches the product (cached),
  // swaps in #quick-buy-content, drives the loading bar, sets `display: contents` on the host,
  // appends to body, traps focus and fires dialog:after-show. The product gallery's carousel
  // controls and swipe initialise off that lifecycle, which is why doing it by hand left them
  // missing. Any failure is logged rather than thrown, so a bad handle cannot break the widget.
  Promise.resolve(quickBuyModal.show()).catch((error) => {
    console.error('Tolstoy quick shop failed to open', error);
  });
}
//This Function is for the onClick Function on Tolstoy Spotlight Carousel "+" button
const subscribeToQuickShopClick =() =>  {
  if (!window.tolstoyWidget || typeof window.tolstoyWidget.subscribe !== 'function') {
    window.addEventListener("tolstoyWidgetReady", subscribeToQuickShopClick, { once: true });
    return;
  }
  window.tolstoyWidget.subscribe(
    "tolstoy_spotlight_carousel_quick_shop_click",
     (o) => {o.product && o.product.handle? openQuickShopModal(o.product): console.error("Product handle is not available in the event");},
    { disableDefault: !0 },
  );
}

window.tolstoyWidget ? subscribeToQuickShopClick(): window.addEventListener("tolstoyWidgetReady", subscribeToQuickShopClick, { once: true });
